import './Header.scss'
import {  
  Image
} from '@fluentui/react-components';
import wrypailogo from "../../assets/logo192.png";
import { Link } from "react-router-dom";
import { useState } from 'react';
import { useAuth } from "../../auth/AuthProvider";
import {NavDrawer, NavDrawerBody, NavItem,Hamburger,
} from '@fluentui/react-components'

function Header()
{    
    const {isAuthenticated, logout} = useAuth();
    const [isOpen, setIsOpen] = useState(false);
    return(
        <>                    
        <div className='app-name d-flex justify-content-between'>
            <div>
                <Link to='/'>
                    <Image className='app-logo' alt="wryp.ai logo" src={wrypailogo}/>
                </Link> 
            </div>
            <div className='app-word-header'>
                <h1>Wryp.AI</h1>
            </div>
            <div>                
                <Hamburger
                    onClick={() => setIsOpen(!isOpen)}                        
                    aria-expanded={isOpen}
                />                
            </div>
        </div>        
        <div className='d-flex flex-row-reverse menu' onClick={() => setIsOpen(!isOpen)}>
                <NavDrawer
                    open={isOpen}
                    type='overlay'
                >                    
                    <NavDrawerBody>
                        <Link to="/">
                            <NavItem value="0">Home</NavItem>
                        </Link>

                        {!isAuthenticated && <Link to="/login">
                            <NavItem value="1">Login</NavItem>
                        </Link>}

                        {!isAuthenticated && <Link to="/create-account">
                            <NavItem value="2">Create Account</NavItem>
                        </Link>}               
                        
                        {isAuthenticated && <Link to="/searchimage">
                            <NavItem value="3">Search</NavItem>
                        </Link>}                        
                        
                        {isAuthenticated && <Link to="/profile">
                            <NavItem value="4">Profile</NavItem>
                        </Link> }

                        {isAuthenticated && <Link to="/subscription">
                        <NavItem value="5">Subscription</NavItem>
                        </Link>} 

                        {isAuthenticated && <Link onClick={logout}>
                            <NavItem value="6">Logout</NavItem>
                        </Link>}
                    </NavDrawerBody>                       
                </NavDrawer>     
            </div>
        </>
        
    );
}

export default Header;